var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileFvlBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Canvas",
    transform: "translate(11033 -935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__file-fvl-bw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path0_fill",
    transform: "matrix(1 0 0 -1 -11022 966.368)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path1_fill",
    transform: "matrix(1 0 0 -1 -11017.5 974.665)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__mask0_alpha",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__mask0_outline_ins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path1_fill",
    transform: "matrix(1 0 0 -1 -11017.5 974.665)",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Group",
    mask: "url(#file-fvl-bw_svg__file-fvl-bw_svg__mask0_alpha)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -11018.3 975.527)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -11014.7 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -11014.7 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -11014.7 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -11014.7 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -11002.4 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -11002.4 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -11002.4 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -11002.4 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -11014.7 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -11002.4 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -11010.2 968.189)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__file-fvl"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Canvas"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path8_fill",
    transform: "translate(-11033 935)",
    fill: "#D9DEE0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl-bw_svg__file-fvl-bw_svg__path9_fill",
    transform: "translate(-11018 979.119)",
    fill: "#FFFFFF"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path0_fill",
    d: "M 2.00509 0.771819L 5.80639 0L 17.8304 9.4341L 18.1269 10.2382C 18.3157 10.8901 18.2078 11.5942 17.8304 12.168C 17.4799 12.7417 16.8868 13.1589 16.2128 13.3154L 5.80639 15.7667C 5.61769 15.8189 5.40202 15.845 5.18635 15.845C 4.70107 15.845 4.24276 15.7146 3.81139 15.4799C 3.21828 15.1409 2.78692 14.5672 2.62517 13.9152L 0.0909576 3.84904C -0.0977599 3.19709 0.0100785 2.49298 0.387514 1.91926C 0.73799 1.34554 1.3311 0.92829 2.00509 0.771819Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path1_fill",
    d: "M 2.97151 0L 16.6405 0C 18.267 0 19.612 1.31411 19.612 2.97238L 19.612 16.6453C 19.612 18.2723 18.2983 19.6177 16.6405 19.6177L 2.97151 19.6177C 1.345 19.6177 0 18.3036 0 16.6453L 0 2.97238C 0 1.3454 1.31372 0 2.97151 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path2_fill",
    d: "M 17.5026 -2.61531e-09L 3.8337 -2.61531e-09L 3.8337 1.72439L 17.5026 1.72439L 17.5026 -2.61531e-09ZM 3.8337 -2.61531e-09C 1.6936 -2.61531e-09 -2.61531e-09 1.73757 -2.61531e-09 3.83458L 1.72439 3.83458C 1.72439 2.6776 2.65823 1.72439 3.8337 1.72439L 3.8337 -2.61531e-09ZM -2.61531e-09 3.83458L -2.61531e-09 17.5075L 1.72439 17.5075L 1.72439 3.83458L -2.61531e-09 3.83458ZM -2.61531e-09 17.5075C -2.61531e-09 19.6477 1.7367 21.3421 3.8337 21.3421L 3.8337 19.6177C 2.67769 19.6177 1.72439 18.684 1.72439 17.5075L -2.61531e-09 17.5075ZM 3.8337 21.3421L 17.5026 21.3421L 17.5026 19.6177L 3.8337 19.6177L 3.8337 21.3421ZM 17.5026 21.3421C 19.6428 21.3421 21.3364 19.6046 21.3364 17.5075L 19.612 17.5075C 19.612 18.6645 18.6781 19.6177 17.5026 19.6177L 17.5026 21.3421ZM 21.3364 17.5075L 21.3364 3.83458L 19.612 3.83458L 19.612 17.5075L 21.3364 17.5075ZM 21.3364 3.83458C 21.3364 1.69446 19.5997 -2.61531e-09 17.5026 -2.61531e-09L 17.5026 1.72439C 18.6587 1.72439 19.612 2.65814 19.612 3.83458L 21.3364 3.83458Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path3_fill",
    d: "M 1.5367 0L 0 0L 0 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path4_fill",
    d: "M 1.5367 0L 0 0L 0 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path5_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path6_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path7_fill",
    d: "M 0.296556 6.58474C 0.242636 6.58474 0.188717 6.58474 0.161758 6.55864C 0.0539188 6.50652 -6.34803e-15 6.40219 -6.34803e-15 6.29787L -6.34803e-15 0.299899C -6.34803e-15 0.195586 0.0539188 0.0912734 0.161758 0.0391173C 0.269596 -0.0130391 0.377435 -0.0130391 0.458315 0.0391173L 5.49978 3.03811C 5.58064 3.09026 5.63458 3.19457 5.63458 3.29889C 5.63458 3.4032 5.58064 3.48144 5.49978 3.55967L 0.458315 6.53258C 0.404395 6.55864 0.350475 6.58474 0.296556 6.58474Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path8_fill",
    d: "M 35.7147 0L 3.57076 0C 1.60081 0 7.27601e-17 1.55148 7.27601e-17 3.47066L 7.27601e-17 58.6161C 7.27601e-17 60.5333 1.60081 62.087 3.57076 62.087L 46.4292 62.087C 48.4033 62.087 50 60.5333 50 58.6161L 50 13.8826L 35.7147 0ZM 35.7147 4.90695L 44.951 13.8826L 35.7147 13.8826L 35.7147 4.90695ZM 46.4296 58.6161L 3.57076 58.6161L 3.57076 3.47066L 32.1432 3.47066L 32.1432 13.8826C 32.1432 15.7997 33.7404 17.3533 35.7139 17.3533L 46.4292 17.3533L 46.4292 58.6161L 46.4296 58.6161Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl-bw_svg__file-fvl-bw_svg__path9_fill",
    d: "M 0.538021 8.08046C 0.386283 8.08046 0.258665 8.02871 0.155207 7.92525C 0.0517494 7.82179 -1.65741e-07 7.69422 -1.65741e-07 7.54244L -1.65741e-07 0.538009C -1.65741e-07 0.379366 0.0517494 0.251759 0.155207 0.155195C 0.258665 0.051733 0.386283 4.6792e-08 0.538021 4.6792e-08L 5.21456 4.6792e-08C 5.37319 4.6792e-08 5.50077 0.0482844 5.59737 0.144849C 5.69393 0.234516 5.74221 0.355221 5.74221 0.506967C 5.74221 0.651816 5.69393 0.769073 5.59737 0.858744C 5.50077 0.948412 5.37319 0.993243 5.21456 0.993243L 1.076 0.993243L 1.076 3.50738L 4.04542 3.50738C 4.19716 3.50738 4.32131 3.55566 4.41787 3.65226C 4.52133 3.74193 4.57308 3.85918 4.57308 4.00402C 4.57308 4.14886 4.52133 4.26958 4.41787 4.36614C 4.32131 4.4558 4.19716 4.50066 4.04542 4.50066L 1.076 4.50066L 1.076 7.54244C 1.076 7.69422 1.02429 7.82179 0.920835 7.92525C 0.817377 8.02871 0.689759 8.08046 0.538021 8.08046ZM 13.0156 4.6792e-08C 13.1674 4.6792e-08 13.2847 0.0413831 13.3674 0.124153C 13.4571 0.206928 13.5019 0.313838 13.5019 0.444889C 13.5019 0.527659 13.4812 0.61733 13.4398 0.713895L 10.3774 7.73903C 10.2877 7.96663 10.1256 8.08046 9.89105 8.08046C 9.67034 8.08046 9.50824 7.96663 9.40478 7.73903L 6.37332 0.807011C 6.31815 0.662162 6.29056 0.541457 6.29056 0.444889C 6.29056 0.306941 6.33194 0.200026 6.41471 0.124153C 6.50437 0.0413831 6.62509 4.6792e-08 6.77683 4.6792e-08C 7.01823 4.6792e-08 7.1838 0.10691 7.27347 0.320735L 9.88072 6.56989L 12.5294 0.320735C 12.5776 0.196578 12.6397 0.113808 12.7156 0.0724245C 12.7915 0.0241402 12.8915 4.6792e-08 13.0156 4.6792e-08ZM 15.2743 8.08046C 15.1225 8.08046 14.995 8.02871 14.8915 7.92525C 14.7949 7.82179 14.7466 7.69422 14.7466 7.54244L 14.7466 0.538009C 14.7466 0.386263 14.7984 0.258657 14.9018 0.155195C 15.0053 0.051733 15.1294 4.6792e-08 15.2743 4.6792e-08C 15.4261 4.6792e-08 15.5536 0.051733 15.6571 0.155195C 15.7606 0.258657 15.8123 0.386263 15.8123 0.538009L 15.8123 7.00446L 19.5577 7.00446C 19.7094 7.00446 19.837 7.05616 19.9405 7.15962C 20.0439 7.26308 20.0957 7.3907 20.0957 7.54244C 20.0957 7.69422 20.0439 7.82179 19.9405 7.92525C 19.837 8.02871 19.7094 8.08046 19.5577 8.08046L 15.2743 8.08046Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFvlBw);
export default __webpack_public_path__ + "static/media/file-fvl-bw.894b5ed67b5d6e5c577cb1d192f74ab2.svg";
export { ForwardRef as ReactComponent };